/* eslint-disable @typescript-eslint/no-explicit-any */
import { boolean, object, string } from 'yup';

import { Publisher } from '../../modules/publisher/publisherApiTypes';

export interface PublisherFormInputs {
  id?: string;
  name?: string;
  displayName: string;
  icon?: string | null;
  isAdformPublisher?: boolean;
}
export const MAX_LENGTH = 30;

export const schema = object().shape({
  id: string().when('isAdformPublisher', {
    is: true,
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.trim().required('ID is required'),
  }),
  name: string().optional(),
  displayName: string().trim().required('Display name is required'),
  icon: string().nullable(),
  isAdformPublisher: boolean().optional(),
});

export type CreatePublisherModalProps = {
  onClose: () => void;
};

export type EditPublisherModalProps = {
  onClose: () => void;
  selectedPublisher: Publisher | null | undefined;
};

export type DeletePublisherModalProps = {
  onClose: () => void;
  selectedPublisher: undefined | Publisher;
};

export type UploadFileModalProps = {
  onClose: () => void;
};
